import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/windDirection.svg'


const _hoisted_1 = { class: "flex justify-content-between align-items-center w-full mb-6" }
const _hoisted_2 = { class: "font-semibold text-xl" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-column pt-2 h-full"
}
const _hoisted_4 = { class: "mb-5 flex justify-between items-center" }
const _hoisted_5 = { class: "flex items-center flex-1" }
const _hoisted_6 = { class: "font-semibold text-7xl" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-7xl" }, "°c", -1)
const _hoisted_8 = { class: "flex align-items-center grid" }
const _hoisted_9 = { class: "col-4 flex flex-column gap-3" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "col flex flex-column gap-3" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = ["alt"]
const _hoisted_16 = { class: "flex mt-auto justify-content-between" }
const _hoisted_17 = { class: "font-semibold" }
const _hoisted_18 = { class: "flex gap-2 mt-1" }
const _hoisted_19 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconAlert = _resolveComponent("IconAlert")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", {
    tabindex: "1",
    class: "flex flex-column bg-white border-round-3xl border-1 border-300 p-4 w-20rem sm:w-25rem h-28rem cursor-pointer",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'Weather' }))),
    onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$router.push({ name: 'Weather' })), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("widgets.weather.title")), 1),
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "icon-warpit_icon_settings text-2xl",
            tabindex: "1",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('edit')), ["stop"])),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('edit')), ["stop"]), ["enter"]))
          }, null, 32))
        : _createCommentVNode("", true)
    ]),
    (_ctx.currentWeather)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currentWeather.temperature), 1),
              _hoisted_7,
              _createElementVNode("span", {
                class: _normalizeClass(["weatherIcon ml-5 inline-block", _ctx.currentWeather.icon])
              }, null, 2)
            ]),
            (_ctx.alerts && _ctx.alerts.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["inline-flex align-items-center gap-2 border-round-xl px-2 py-1 font-bold ml-auto", {
            'bg-red-200 text-red-700': _ctx.severityColor === 'red',
            'bg-orange-200 text-orange-700': _ctx.severityColor === 'orange',
          }])
                }, [
                  _createVNode(_component_IconAlert),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("weather.alerts.alert")), 1)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("widgets.weather.humidity")), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("widgets.weather.pressure")), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("widgets.weather.wind")), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, _toDisplayString(_ctx.currentWeather.humidity) + "%", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.currentWeather.pressure) + " hPa", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.currentWeather.windSpeed) + " km/h - " + _toDisplayString(_ctx.currentWeather.windDirection), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("img", {
                class: "w-5rem",
                style: _normalizeStyle({
              transform: 'rotate(' + _ctx.currentWeather.windBearing + 'deg)',
            }),
                src: _imports_0,
                alt: _ctx.$t('accessibility.weather.wind')
              }, null, 12, _hoisted_15)
            ])
          ]),
          _createVNode(_component_Divider),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forecastData, (daily) => {
              return (_openBlock(), _createElementBlock("div", {
                key: daily.time,
                class: "flex flex-column"
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$moment.unix(daily.time).format("dddd")), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$moment.unix(daily.time).format("DD. MM.")), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["weatherIcon", daily.icon])
                }, null, 2),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(daily.temperatureHigh.toFixed(0)) + "°C", 1),
                  _createElementVNode("span", null, _toDisplayString(daily.temperatureLow.toFixed(0)) + "°C", 1)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}